module.exports = __webpack_public_path__ + "img/sirius-chain.844bd7fb.png";